import React from "react";
import {
      Container,
      Typography,
      Box,
      Grid,
      Card,
      CardContent,
} from "@mui/material";
import CustomButton from "../../components/CustomButton";
import HeroSection from "./HeroSection";
import PlansSection from "./PlansSection";
import FAQsSection from "../HomeScreen/FAQsSection";
import SubscribeSection from "../HomeScreen/SubscribeSection";
import ParallaxItem from "../../components/ParallexSection";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const PricingPage = () => {

  const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
      return (
            <Box sx={{ backgroundColor: "#F3F9FF", mt: isMobile?11:9, }}>
                  <Box sx={{ my: 0, p: 0 }}>
                        <HeroSection />
                  </Box>
                  {/* <Box sx={{ backgroundColor: "white" }}>
                        <PlansSection />
                  </Box> */}
      
                  <Box sx={{ backgroundColor: "white", pb: isMobile ? 2 : 4 }}>
                 
                           <FAQsSection />
                    
                          
                  </Box>
                

                  {/* <Box>
                        <SubscribeSection />
                  </Box> */}
            </Box>

      );
};

export default PricingPage;
